export default __webpack_public_path__ + "static/media/d9766e27fe0a7573.03b01215b795b00b180f5a4aea953807.svg";